import { Component, Directive, TemplateRef, inject, input } from '@angular/core';

// description directive
@Directive({
    selector: 'ng-template[storyDescription]',
})
export class StoryDescriptionDirective {
    public template = inject(TemplateRef<never>);
}

// card component
@Component({
    selector: 'story-description',
    template: `
        <p class="{{ className() }}">
            <ng-content></ng-content>
        </p>
    `,
})
export class StoryDescriptionComponent {
    className = input<string | undefined>('aui-font-regular-16 leading-[1.5]');
}
